import { Component, OnInit } from '@angular/core';
import { PersonService } from '../person.service';
@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.css']
})
export class ResumeComponent implements OnInit {
  person;
  languagePanel:boolean=true;
  databasePanel:boolean=false;
  frameworkPanel:boolean=false;
  conceptPanel:boolean=false;
  c:boolean=false;
  constructor(private personService:PersonService) { }
  onWritingComplete()
  {
    this.c=true;
  }
  setLanguageState()
  {
    this.languagePanel=true;
    this.databasePanel=false;
    this.frameworkPanel=false;
    this.conceptPanel=false;
  }
  setDatabaseState()
  {
    this.languagePanel=false;
    this.databasePanel=true;
    this.frameworkPanel=false;
    this.conceptPanel=false;
  }
  setFrameworkState()
  {
    this.languagePanel=false;
    this.databasePanel=false;
    this.frameworkPanel=true;
    this.conceptPanel=false;
  }
  setConceptState()
  {
    this.languagePanel=false;
    this.databasePanel=false;
    this.frameworkPanel=false;
    this.conceptPanel=true;
  }

  ngOnInit() {
    this.person=this.personService.person;
  }

}
